import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";
import "./i18n";

// const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
// TagManager.initialize({ gtmId });

const devMode = import.meta.env.VITE_IS_DEBUG;
if (devMode !== "true") {
  Sentry.init({
    dsn: "https://03b46591f76a5ebfe7f0e2e85ce90d4c@o4508133136662528.ingest.us.sentry.io/4509793536114688",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.getbrandkarma\.com\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  console.debug("Dev mode, no Sentry init...");
}

const trackingKey = import.meta.env.VITE_MIXPANEL_TRACKING_KEY;
if (devMode === "true") {
  mixpanel.init(trackingKey, {
    debug: true,
    track_pageview: true,
    ignore_dnt: false,
    persistence: "localStorage",
  });
  console.warn("TRACKING IN DEV MODE!");
} else {
  mixpanel.init(trackingKey, {
    debug: false,
    track_pageview: true,
    ignore_dnt: true,
    persistence: "localStorage",
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
